import { useCallback, useMemo, useState } from 'react'
import ConfirmModal from 'components/modals/ConfirmModal'

const confirmText = (
  <span>
    Please note that upon confirmation, the trainee will not have access to the trainee portal until
    a new access code is assigned. For assistance with new code activation, please contact support
    at <a href="mailto:contact@proactivememoryservices.com">contact@proactivememoryservices.com</a>.
    Be aware that this change will incur an additional licensing fee.
  </span>
)

export function useUnlicensedConfirm() {
  const [showUnlicensedConfirm, setShowUnlicensedConfirm] = useState(false)
  const [resolvePromise, setResolvePromise] = useState<(value: boolean) => void>(() => {})

  const openUnlicensedConfirm = useCallback((): Promise<boolean> => {
    setShowUnlicensedConfirm(true)
    return new Promise<boolean>((resolve) => {
      setResolvePromise(() => resolve)
    })
  }, [])

  const closeUnlicensedConfirm = useCallback(() => {
    setShowUnlicensedConfirm(false)
  }, [])

  const handleClose = useCallback(() => {
    setShowUnlicensedConfirm(false)
    resolvePromise(false)
  }, [resolvePromise])

  const handleConfirm = useCallback(() => {
    setShowUnlicensedConfirm(false)
    resolvePromise(true)
  }, [resolvePromise])

  const unlicensedConfirm = useMemo(
    () =>
      showUnlicensedConfirm && (
        <ConfirmModal
          title=""
          loading={false}
          body={confirmText}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
        />
      ),
    [showUnlicensedConfirm, handleClose, handleConfirm],
  )

  return { openUnlicensedConfirm, closeUnlicensedConfirm, unlicensedConfirm }
}
